import coverOptionsUrl from './coverShiftOptions.html';

class CoverShiftOptionsCtrl {
  constructor(Authentication, PersonaCollection, PossibleAssignees, ShiftUtils, Utils, sdk) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      PossibleAssignees,
      ShiftUtils,
      Utils,
      sdk,
    });
  }

  $onInit() {
    this.actionTypes = this.getActionTypes();
    this.copyShiftSubaction = this.actionTypes[0];
    this.coverModel.shiftAction = this.copyShiftSubaction.value;

    const eventUserId = this.event?.user?.id;
    this.users = this.PersonaCollection.users.filter((u) => u.id !== eventUserId);

    this.possibleAssignees = new this.PossibleAssignees(this.event, this.users);
  }

  getActionTypes() {
    const { SHIFT_COVER_ACTIONS, NO_SHOW_MAKE_AVAILABLE, NO_SHOW_OFFER } = this.sdk('constants');

    if (this.isPast(this.event.dtstart)) {
      return SHIFT_COVER_ACTIONS.filter(
        (action) => ![NO_SHOW_MAKE_AVAILABLE, NO_SHOW_OFFER].includes(action.value)
      );
    }

    return SHIFT_COVER_ACTIONS;
  }

  shouldShowAssignee() {
    const { NO_SHOW_ASSIGN, NO_SHOW_OFFER } = this.sdk('constants');
    return (
      this.copyShiftSubaction &&
      [NO_SHOW_ASSIGN, NO_SHOW_OFFER].includes(this.copyShiftSubaction.value)
    );
  }

  selectCopyShiftSubaction(copyShiftSubaction) {
    this.copyShiftSubaction = copyShiftSubaction;
    this.coverModel.shiftAction = copyShiftSubaction.value;
  }

  isPast(day) {
    return this.ShiftUtils.isPastDay(day, this.Utils.getNowDate());
  }
}

export default {
  templateUrl: coverOptionsUrl,
  controller: CoverShiftOptionsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    coverModel: '=',
    shiftToModel: '=',
    event: '<',
    userId: '<',
  },
};
